import React from "react";
import { Link } from "react-router-dom";

const Pages401 = () => (
  <div style={{ padding: "48px 24px", maxWidth: 480, margin: "0 auto", textAlign: "center" }}>
    <h1 style={{ fontSize: "1.25rem", fontWeight: 600, marginBottom: 12 }}>
      You do not have access to that page
    </h1>
    <p style={{ color: "#555", marginBottom: 20 }}>
      Go back to the dashboard and open a page your role is allowed to use.
    </p>
    <Link to="/dashboard">Back to dashboard</Link>
  </div>
);

export default Pages401;
